module.exports = __webpack_public_path__ + "static/media/hidden-power-goten.fc0a38aa.png";